var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0a8 8 0 015.657 13.657L8 19.313l-5.657-5.656A8 8 0 018 0zm0 2c-1.603 0-3.11.624-4.242 1.757a6.005 6.005 0 000 8.485L8 16.485l4.242-4.243a6.005 6.005 0 000-8.485A5.96 5.96 0 008 2zm0 4.2c1.104 0 2 .806 2 1.8s-.896 1.8-2 1.8S6 8.994 6 8s.896-1.8 2-1.8z","fillRule":"evenodd"}));
}

Pin.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20"};

module.exports = Pin;

Pin.default = Pin;
